import { FlexColumnDiv, FlexRowDiv } from '@/app/shared/common.StyledComponents';
import { formatDate, formatMoney } from '@/app/shared/utils/tableUtils';
import { useTranslation } from 'react-i18next';
import { InvoiceDetailNavigationCardProps } from '../invoiceDetail.types';
import { InvoiceDetailsCard, InvoiceDetailsColumnHeader, InvoiceDetailsColumnValues, InvoiceDetailsHeader } from '../InvoiceDetail.StyledComponents';

export const InvoiceDetailCard: React.FC<InvoiceDetailNavigationCardProps> = ({
    invoiceDetails
}) => {
    const { t } = useTranslation('invoicesDashboard');
    
    return (
        <InvoiceDetailsCard>
            <InvoiceDetailsHeader>
                {t("invoiceDetail.invoiceDetailsHeader")}
            </InvoiceDetailsHeader>
            <FlexColumnDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.loadNumberHeader")}
                    </InvoiceDetailsColumnHeader>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.invoiceDateHeader")}
                    </InvoiceDetailsColumnHeader>
                </FlexRowDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnValues>
                        {invoiceDetails?.referenceNumber}
                    </InvoiceDetailsColumnValues>
                    <InvoiceDetailsColumnValues>
                        {invoiceDetails?.invoiceDate ? formatDate(invoiceDetails!.invoiceDate!): "N/A"}
                    </InvoiceDetailsColumnValues>
                </FlexRowDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.carrierHeader")}
                    </InvoiceDetailsColumnHeader>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.purchaseDateHeader")}
                    </InvoiceDetailsColumnHeader>
                </FlexRowDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnValues>
                        {invoiceDetails?.clientName}
                    </InvoiceDetailsColumnValues>
                    <InvoiceDetailsColumnValues>
                        {invoiceDetails?.paymentDate ? formatDate(invoiceDetails!.paymentDate!): "N/A"}
                    </InvoiceDetailsColumnValues>
                </FlexRowDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.invoiceTotalHeader")}
                    </InvoiceDetailsColumnHeader>
                    <InvoiceDetailsColumnHeader>
                        {t("invoiceDetail.dueDateHeader")}
                    </InvoiceDetailsColumnHeader>
                </FlexRowDiv>
                <FlexRowDiv>
                    <InvoiceDetailsColumnValues>
                        {formatMoney(invoiceDetails?.amount)}
                    </InvoiceDetailsColumnValues>
                    <InvoiceDetailsColumnValues>
                        {invoiceDetails?.dueDate ? formatDate(invoiceDetails!.dueDate!): "N/A"}
                    </InvoiceDetailsColumnValues>
                </FlexRowDiv>
            </FlexColumnDiv>
        </InvoiceDetailsCard>
  );
};